var _require = require('./core'),
  makeStyledBreakpoints = _require.makeStyledBreakpoints;
var _makeStyledBreakpoint = makeStyledBreakpoints(),
  up = _makeStyledBreakpoint.up,
  down = _makeStyledBreakpoint.down,
  between = _makeStyledBreakpoint.between,
  only = _makeStyledBreakpoint.only;
module.exports = {
  up: up,
  down: down,
  between: between,
  only: only
};